import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getTypePlacement } from '../thunks/placementThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPlacementKey } from '../thunkKeys/placementThunksKeys';

const SLICE_NAME = 'typePlacement';

export const typePlacementSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearTypePlacement(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getTypePlacement });
        builder.addCase(
            clearPlacementKey,
            () => commonInitialState,
        );
    },
});

export const { clearTypePlacement } = typePlacementSlice.actions;

export const typePlacement = typePlacementSlice.reducer;
